module.exports = __webpack_public_path__ + "static/media/bg2.624f2de1.png";